// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'

import SuriApi from '../Services/SuriApi'

import routeNames from '../routes/routeNames'

// redux
import DomexActions, { DomexTypes } from '../Redux/DomexRedux'
import GeneralActions from '../Redux/GeneralRedux'

const DomexEpics = [
	action$ => (
		action$.pipe(
		  ofType(DomexTypes.DOMEX_GET_PARAMS_REQUEST),
			switchMap(() => (
				from(SuriApi.domexParams()).pipe(
          switchMap((response) => {
            if (response.status === 200) {
              return from([
                DomexActions.domexSaveParamsRequestSuccess(response.data),
                GeneralActions.onChangeError({}),
              ])
            }
            throw response
          }),
          catchError(e => of(GeneralActions.onChangeErrorRequest({
            type: 'GET_PARAMS_ERROR',
            message: e,
          })))
        )
			))
    )
	),
	(action$, state$) => (
		action$.pipe(
		  ofType(DomexTypes.DOMEX_CALCULATE_REQUEST),
			switchMap(() => {
				let state = state$.value.domex
				state = {
					giBuiltUpArea: state.giBuiltUpArea,
					giSumInsured: state.giSumInsured,
					hiHouseholdArea: state.hiHouseholdArea,
					hiSumInsured: state.hiSumInsured,
					street: state.street,
					houseNo: state.houseNo,
					zipCode: state.zipCode,
					city: state.city,
					phone: state.phone,
					surname: state.surname,
					householdInsurance: state.householdActive ? 1 : 0,
					hiOccupancyId: state.groundingOccupancyIndex >= 0 ? state.groundingInsurance.occupancy[state.groundingOccupancyIndex].id : 0,
					groundingInsurance: state.propertyActive ? 1 : 0,
					giOccupancyId: state.groundingOccupancyIndex >= 0 ? state.groundingInsurance.occupancy[state.groundingOccupancyIndex].id : 0,
					giPropertyTypeId: state.groundingPropertyTypeIndex >= 0 ? state.groundingInsurance.propertyType[state.groundingPropertyTypeIndex].id : 0,
					liabilityInsurance: state.liabilityActive ? 1 : 0,
					liMaximumLiability: state.maximumLiabilityIndex >= 0 ? state.maximumLiability[state.maximumLiabilityIndex].name : 0,
          gaId: state.gaId,
          website: state.website,
				}

				return from(SuriApi.calculateDomexQuote(state)).pipe(
          switchMap(response => {
            if (response.status === 200) {
              // location.hash = routeNames.final
              return from([
                DomexActions.domexCalculateRequestSuccess(response.data.startingPrice),
                GeneralActions.onChangeRedirectUrl(routeNames.final),
              ])
            }
            throw response
          }),
          catchError(error => {
            if (error.response && error.response.data && error.response.data.errors) {
              return of(DomexActions.domexCalculateRequestFailure(error.response.data.errors))
            }
            return from([
              DomexActions.domexCalculateRequestFailure(error.toString()),
              GeneralActions.onChangeErrorRequest({
                type: 'GET_QUOTE_ERROR',
                message: error,
              })
            ])
          })
        )
			})
    )
	)
]

export default DomexEpics
